<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="float-right" v-if="!loading" id="viewOrderActions">
                    <div class="dropdown">
                        <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMen1" data-toggle="dropdown" data-boundary="viewport" aria-haspopup="true" aria-expanded="false">
                            Actions
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenu1">
                            <button class="dropdown-item" id="btnViewOrderCancel" @click="onCancelOrderClick"
                                    v-show="order.orderStatusId !== orderStatus.cancelled && order.orderStatusId !== orderStatus.complete">
                                Cancel
                            </button>
                            <button class="dropdown-item" id="btnMarkAsOnDeliveryDownload" @click="onMarkAsOnDeliveryClick" 
                                    v-show="order.orderStatusId === orderStatus.scheduledForDelivery && deliveryProcessFeatureFlags.allowToMarkAsOnDelivery">
                                Mark As On Delivery
                            </button>
                            <button class="dropdown-item" id="btnCancelDelivery" @click="onCancelDeliveryScheduleClick"
                                    v-show="order.orderStatusId === orderStatus.onDelivery && deliveryProcessFeatureFlags.allowDeliveryFailure">
                                Cancel Delivery
                            </button>
<!--                            <button class="dropdown-item" id="btnCompleteOrder" @click="onCompleteOrderClick"-->
<!--                                    v-show="order.orderStatusId === orderStatus.onDelivery && deliveryProcessFeatureFlags.allowCompleteOrder">-->
<!--                                Complete Order-->
<!--                            </button>-->
                            <button class="dropdown-item" id="btnCompleteOrder" @click="onCompleteOrderClick"
                                    v-show="order.orderStatusId === orderStatus.onDelivery && deliveryProcessFeatureFlags.allowCompleteOrder">
                                Mark As Pending Invoice
                            </button>
                            <button class="dropdown-item" id="btnOrderDocuments" @click="viewOrderDocuments"
                                    v-show="order.orderStatusId === orderStatus.complete">
                                Documents
                            </button>
                            <button class="dropdown-item" id="btnRescheduleOrder" @click="onRescheduleOrderClick"
                                    v-show="order.orderStatusId === orderStatus.scheduledDeliveryCancelled">
                                Reschedule Order
                            </button>
                            <button class="dropdown-item" id="btnViewOrderDownload" @click="downloadOrderAsPdf">
                                Download
                            </button>
                            <button class="dropdown-item" id="btnViewOrderViewTrackingHistory" @click="viewTrackingHistory">
                                View Tracking History
                            </button>
                        </div>
                    </div>
                </div>
                <div v-if="!loading">
                    <div class="pb-2">
                        <p>
                            <b>Customer:</b> {{order.registeredCompanyName}}
                        </p>
                        <!--                        <p v-if="order.customerBranch">-->
                        <!--                            Branch: {{order.customerBranch}}-->
                        <!--                        </p>-->
                        <p>
                            <b>Order Date:</b> {{order.insertedOn}}
                        </p>
                        <p>
                            <b>Order Type:</b> {{order.orderType}}
                        </p>
                        <p>
                            <b>Order Status:</b> {{order.description}}
                        </p>
                        <!--                        <p v-if="order.placedBy">-->
                        <!--                            Placed By: {{order.placedBy}} (#{{order.placedByUserId}})-->
                        <!--                        </p>-->
                        <p v-if="order.expectedDeliveryDate !== null && order.expectedDeliveryDate !== undefined">
                            <b>Expected Date Of Delivery:</b> {{order.expectedDeliveryDate}}
                        </p>
                        <p v-if="order.orderStatusId === orderStatus.complete">
                            <b>Date Delivered:</b> {{order.statusLastUpdatedOn}}
                        </p>
                    </div>
                    <div class="card border border-secondary mb-3">
                        <div class="card-body text-secondary">
                            <div class="row">
                                <div class="col-6">
                                    <h5 class="card-title text-secondary">Billing Address</h5>
                                    <p v-if="!loadingBillingAddress">
                                        <span v-if="billingAddress">
                                            {{ billingAddress.siteName }}<br>
                                            {{ billingAddress.streetAddress }}<br>
                                            {{ billingAddress.city }} <br>
                                            {{ billingAddress.province }} <br>
                                            {{ billingAddress.postalCode }}<br>
                                            <!--                                {{ billingAddress.country }}-->
                                        </span>
                                                <span v-else>
                                            No billing address found.
                                        </span>
                                    </p>
                                    <p v-if="loadingBillingAddress">Loading...</p>
                                </div>
                                <div class="col-6">
                                    <h5 class="card-title text-secondary">Shipping Address</h5>
                                    <p v-if="!loadingBillingAddress">
                                        <span v-if="shippingAddress">
                                            {{ shippingAddress.siteName }}<br>
                                            {{ shippingAddress.streetAddress }}<br>
                                            {{ shippingAddress.city }} <br>
                                            {{ shippingAddress.province }} <br>
                                            {{ shippingAddress.postalCode }}<br>
                                            <!--                                {{ billingAddress.country }}-->
                                        </span>
                                        <span v-else>
                                            No shipping address found.
                                        </span>
                                    </p>
                                    <p v-if="loadingBillingAddress">Loading...</p>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="card border border-secondary pt-2">
                        <div class="card-body text-secondary">
                            <h5 class="card-title text-secondary">Items Ordered</h5>
                            <order-items-table
                                    :orderId="orderId"
                                    :orderTotal="orderGrandTotal"></order-items-table>
                            
                        </div>
                    </div>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>
    <div class="modal fade" :id="cancelOrderModalId" tabindex="-1" aria-labelledby="cancelOrderModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header modal-header-warning">
                    <h5 class="modal-title" id="cancelOrderModalLabel">Cancel Order #{{order.orderId}}?</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    Cancel Order? Are you sure?
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal">
                        No
                    </button>
                    <button type="button" class="btn btn-outline-primary waves-effect waves-light"
                            @click="onCancelYesClick"
                            :disabled="loading">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                        Yes
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" :id="markAsOnDeliveryModalId" tabindex="-1" aria-labelledby="markAsOnDeliveryModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header modal-header-warning">
                    <h5 class="modal-title" id="markAsOnDeliveryModalLabel">Mark Order #{{order.orderId}} As On Delivery?</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    Mark Order As On Delivery? Are you sure?
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal">
                        No
                    </button>
                    <button type="button" class="btn btn-outline-primary waves-effect waves-light"
                            @click="onMarkAsOnDeliveryYesClick"
                            :disabled="loading">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                        Yes
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" :id="cancelOrderScheduledForDeliveryModalId" tabindex="-1" aria-labelledby="cancelOrderScheduledForDeliveryModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header modal-header-warning">
                    <h5 class="modal-title" id="cancelOrderScheduledForDeliveryModalLabel">Fail Order Scheduled For Delivery #{{order.orderId}}?</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    Select Reason
                    <div class="table-responsive pt-4" v-if="!loading">
                        <table class="table table-hover mb-0">
                            <thead>
                            <tr>
                                <th>Reason</th>
                                <th>
                                    Select
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(reason, index) in reasonsForDeliveryFailure" :key="index">
                                <td>{{reason.reason}}</td>
                                <td>
                                    <button class="btn btn-primary" @click="onReasonSelect(reason)">Select</button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <loading-spinner :showSpinner="loading"></loading-spinner>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" :disabled="loading">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" :id="completeOrderConfirmationModalId" tabindex="-1" aria-labelledby="completeOrderConfirmationModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header modal-header-success">
                    <h5 class="modal-title" id="completeOrderConfirmationModalLabel">Complete Order #{{order.orderId}}?</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label>Date of Completion</label>
                        <div class="text-danger" v-if="dateOfCompletion.hasError">
                            {{dateOfCompletion.errorMessage}}
                        </div>
                        <date-picker :format="'DD/MM/YYYY'" :elementId="'dateOfCompletionSelect'" :date="dateOfCompletion.value"
                                     :initialiseDate="dateOfCompletion.initialiseDate"
                                     @dateChange="onDateOfCompletionSelect"></date-picker>
                    </div>
                    <div class="text-danger" v-if="orderItemsHasError">
                        {{orderItemsErrorMessage}}
                    </div>
                    <dispense-order-item-for-order-table
                        :orderId="order.orderId"
                        @dispenseUpdate="onDispenseUpdate"></dispense-order-item-for-order-table>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal">
                        Cancel
                    </button>
                    <button type="button" class="btn btn-outline-primary waves-effect waves-light"
                            @click="onCompleteOrderYesClick"
                            :disabled="loading">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                        Save
                    </button>
                </div>
            </div>
        </div>
    </div>
    <tracking-history-modal
            :heading="trackingHistoryModal.heading"
            :modalId="trackingHistoryModal.modalId"
            :showModal="trackingHistoryModal.showModal"
            :orderId="trackingHistoryModal.orderId"
            @okButtonClicked="onTrackingHistoryOkButtonClicked"></tracking-history-modal>
    <order-documents-modal
            :orderId="documentsModal.orderId"
            :heading="documentsModal.heading"
            :modalId="documentsModal.modalId"
            :showModal="documentsModal.showModal"
            :orderTypeId="documentsModal.orderTypeId"
            @closeModal="onDocumentsModalClose"></order-documents-modal>
</div>
